
import {throwError as observableThrowError,  Observable } from 'rxjs';
import { BaseService } from 'iui-iconectiv-lib';
import { GenericResponse } from './baseresponse';
import { Injectable } from '@angular/core';

// lodash
declare const _: any;

@Injectable()
export class GenericService extends BaseService {
  isSuccess(rsp: GenericResponse): boolean {
    return ('success' === rsp.status);
  }

  isStale(rsp: GenericResponse): boolean {
    return (('fail' === rsp.status) &&
      (rsp.messages) &&
      (rsp.messages.length > 0) &&
      (rsp.messages[0].code === 'CC-5058'));
  }

  getServer(settings: any) {
    if (Array.isArray(settings.servers)) {
      const len = settings.servers.length;
      const idx = Math.floor(Math.random() * len);
      return settings.servers[idx];
    }
    else {
      return '';
    }
  }


  isInt(n: number) {
    return Number(n) === n && n % 1 === 0;
  }

  getTimeoutObservable(to: number): Observable<any> {
    return observableThrowError({ 'status': 'FAILED', timeout: to });
  }

  /**
   * Cleans a JSON object of empty arrays, empty objects
   */
  clean(o: any): CleanResult {
    // console.debug('clean2 ' + JSON.stringify(o));
    let rv = new CleanResult(o, false);

    if (Array.isArray(o)) {
      const a: any[] = o;
      const removeFromArray = [];
      a.forEach((oo, idx) => {
        const r = this.clean(oo);
        if (r.empty) {
          removeFromArray.push(oo);
        }
        else {
          a[idx] = r.o;
        }
      });
      // console.debug('array remove list ' + JSON.stringify(removeFromArray) + ' for ' + JSON.stringify(a));
      _.remove(a, item => removeFromArray.indexOf(item) >= 0);
      //  console.debug('a is now ' + JSON.stringify(a));
      rv = new CleanResult(a, a.length === 0);
    }
    else if (typeof o === 'object') {
      if (o === null) {
        rv = new CleanResult(o, true);
      }
      else {
        for (const p in o) {
          if (o.hasOwnProperty(p)) {
            const r = this.clean(o[p]);
            if (r.empty) {
              delete o[p];
            }
            else {
              o[p] = r.o;
            }
          }
        }
        rv = new CleanResult(o, Object.keys(o).length === 0);
      }
    }
    else {
      rv.empty = ((o === undefined) || ('' === o));
    }

    // console.debug('c2 result ' + rv.empty + ' ' + JSON.stringify(rv.o));
    return rv;
  }
}

/**
 * Paging information for queries to the back end.
 */
export class QueryPaging {
  constructor(public page: number, public limit: number) {

  }
}

/**
 * Internal class used during cleanup of campaigns sent to the back end.
 */
class CleanResult {
  constructor(public o: any, public empty: boolean) {

  }
}


/**
 * Wrapper for MongoDB object IDs.
 */
export class MongoId {
  get oid(): string {
    return this['$oid'];
  }
  set oid(oid: string) {
    this['$oid'] = oid;
  }
}

export class SortCriteria {
  constructor(public column: string, public descending: boolean) {

  }
}

export class SelectedCarrier {
  companyId: string;
  addressTypes: string[];
}

export class AssociatedCarrier extends SelectedCarrier {
  preselected: string[];
}
